// @flow
import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import reduce from 'ramda/es/reduce';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';


type Schools = {
  [key: string]: {
    id: number,
    title: string,
  }
}

export default function useSchools() {
  const { data: students, loading } = useSelector(state => state.students, shallowEqual);
  const [schools, schoolsIds] = useMemo(() => {
    const schoolsObj = pipe(
      values,
      reduce((acc, student) => {
        const { schoolId, school } = student;
        return { ...acc, [schoolId]: { id: schoolId, title: school } };
      }, {})
    )(students);
    const ids = map(prop('id'), values(schoolsObj));

    return [schoolsObj, ids];
  }, [students]);

  return [(schools: Schools), (schoolsIds: Array<number>), (loading: boolean)];
}
